<div class="flex flex-row items-center">
    <div class="w-1/2 rounded bg-background flex flex-row items-center justify-around p-4">
        <fa-icon
            class="text-custom-extra-dark-grey"
            size="2xl"
            [icon]="['far', 'file-arrow-down']" />
        <div class="flex flex-col items-start ml-4 w-full text-custom-extra-dark-grey">
            <span class="text-base font-medium underline underline-offset-2">{{ file().name }}</span>
            <div class="flex flex-row items-center justify-between w-full">
                <span class="text-sm font-normal">{{ file().type }}</span>
                <span class="text-sm font-normal">{{ file().size | byteFormat }}</span>
            </div>
        </div>
    </div>

    <button
        class="ml-4 rounded-full p-4 border-none bg-transparent hover:bg-background hover:cursor-pointer"
        (click)="deleteFile(); $event.preventDefault()">
        <fa-icon
            class="text-custom-extra-dark-grey"
            size="lg"
            [icon]="['fas', 'trash']" />
    </button>
</div>
